import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { DailyLogFriendProfilePost, DailyLogMyProfilePost, DailyLogPost } from 'src/app/interfaces/daily-log'
import { extractTextFromTextEditorContent } from 'src/utils/daily-log-content'

@Component({
  selector: 'app-daily-log-content',
  templateUrl: './daily-log-content.component.html',
  styleUrls: ['./daily-log-content.component.scss'],
})
export class DailyLogContentComponent implements OnChanges {
  constructor() {}

  @Input() data: DailyLogMyProfilePost | DailyLogFriendProfilePost | DailyLogPost | undefined
  isContentEmpty: boolean = false

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('data') && changes.data.currentValue) {
      const data: DailyLogPost = changes.data.currentValue ?? ''
      this.isContentEmpty = extractTextFromTextEditorContent(data.content) === ''
    }
  }
}
